import React from 'react';
import { View } from 'react-native';

// Web placeholder for NativeVideoPlayer (not used on web)
export const NativeVideoPlayer = (props: any) => {
  return <View {...props} />;
};